module.exports = __webpack_public_path__ + "img/makeup-active.2be6482c.png";